import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import {
  logIn,
  pingHelloWorld,
  userHasNalogCookie,
  getAndStoreUserDataBySession
} from '../utils/auth';
import { useEffect } from 'react';
import { LOGIN_REDIRECT } from '../constants/config';
import LoadingIndicator from './LoadingIndicator';
import { last } from 'lodash';

interface Props {
  setIsAuthorizing: React.Dispatch<React.SetStateAction<boolean>>;
}

const AuthorizationNoConsent: React.FC<Props> = ({ setIsAuthorizing }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const redirected = searchParams.get(SEARCH_PARAMS.REDIRECTED) === 'true';
  const hasNalogCookie = userHasNalogCookie();

  const currentPage = last(window.location.pathname.split('/'));
  const redirectPage = last(LOGIN_REDIRECT.split('/'));

  // 1. Start a fresh flow which may end up going to the login redirect page and then back here again.
  const initFreshAuthorizationFlow = async () => {
    try {
      await pingHelloWorld().then(async response => {
        if (response.session === null) {
          // Start the login process (go to Nalog and then back to the login redirect page).
          logIn();
        } else {
          // The user is logged in, fetch consents and user data.
          await getAndStoreUserDataBySession();

          // END OF FLOW.
          setIsAuthorizing(false);
        }
      });
    } catch (e) {
      // If an error occurs and the user has a cookie, try to log him in "the long way round".
      console.warn(
        'Autorizacioni flow (no consent) nije uspeo, pokušavam login:',
        e
      );
      logIn();
    }
  };

  // 2. Handle user that just got here from the login redirect page.
  const cleanUpSearchParamsAndEndAuthFlow = async () => {
    try {
      searchParams.delete(SEARCH_PARAMS.REDIRECTED);
      setSearchParams(searchParams);

      // END OF FLOW.
      setIsAuthorizing(false);
    } catch (e) {
      // Drop out fully.
      setIsAuthorizing(false);
      navigate('/');
    }
  };

  // Main login logic.
  useEffect(() => {
    // Don't do anything on the login redirect page or the privacy settings page.
    if (currentPage === redirectPage) {
      return;
    }

    if (!hasNalogCookie) {
      // END OF FLOW.
      setIsAuthorizing(false);
    } else {
      if (redirected) {
        // 2. Handle user that just got here from the login redirect page.
        cleanUpSearchParamsAndEndAuthFlow();
      } else {
        // 1. Start a fresh flow which may end up going to the login redirect page and then back here again.
        initFreshAuthorizationFlow();
      }
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <div className="d-flex justify-content-center align-items-center full-height">
      <LoadingIndicator />
    </div>
  );
};

export default AuthorizationNoConsent;
